import { render, staticRenderFns } from "./BtnAtualizarParcelamento.vue?vue&type=template&id=0fe58af0&"
import script from "./BtnAtualizarParcelamento.vue?vue&type=script&lang=js&"
export * from "./BtnAtualizarParcelamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports